import { useState } from 'react'

interface Feed {
  id: number
  title: string
  updated_at: string
  subscription_id: number | null
}

function timeAgo(dateString: string): string {
  const seconds = Math.floor((Date.now() - new Date(dateString).getTime()) / 1000)
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d ago`
  const months = Math.floor(days / 30)
  return `${months}mo ago`
}

const FEEDS_PREVIEW_COUNT = 5

interface SidebarProps {
  feeds: Feed[]
  categories: string[]
  activeFeedId: number | null
  activeCategory: string | null
  onSelectFeed: (feedId: number | null) => void
  onSelectCategory: (category: string) => void
  onCollapse: () => void
}

export default function Sidebar({ feeds, categories, activeFeedId, activeCategory, onSelectFeed, onSelectCategory, onCollapse }: SidebarProps) {
  const [showAllFeeds, setShowAllFeeds] = useState(false)
  const visibleFeeds = showAllFeeds ? feeds : feeds.slice(0, FEEDS_PREVIEW_COUNT)
  const hasMore = feeds.length > FEEDS_PREVIEW_COUNT

  return (
    <aside id="sidebar">
      <div className="sidebar-header">
        <button className="sidebar-collapse-btn" onClick={onCollapse} title="Collapse sidebar">
          &laquo;
        </button>
      </div>

      <h3>Feeds</h3>
      <ul>
        <li>
          <a href="#" onClick={(e) => { e.preventDefault(); onSelectFeed(null) }}
             className={!activeFeedId && !activeCategory ? 'active' : ''}>
            All Articles
          </a>
        </li>
        {visibleFeeds.map((feed) => (
          <li key={feed.id}>
            <a href="#" onClick={(e) => { e.preventDefault(); onSelectFeed(feed.id) }}
               className={activeFeedId === feed.id ? 'active' : ''}>
              <span className="feed-link-title">
                {feed.subscription_id ? (
                  <a href={`/feed_subscriptions/${feed.subscription_id}`}
                     onClick={(e) => e.stopPropagation()}
                     className="feed-name-link">
                    {feed.title}
                  </a>
                ) : feed.title}
              </span>
              {feed.updated_at && <span className="feed-updated-at">{timeAgo(feed.updated_at)}</span>}
            </a>
          </li>
        ))}
        {hasMore && (
          <li>
            <a href="#" className="see-more-link" onClick={(e) => { e.preventDefault(); setShowAllFeeds(!showAllFeeds) }}>
              {showAllFeeds ? 'Show less' : `See all ${feeds.length} feeds`}
            </a>
          </li>
        )}
      </ul>

      {categories.length > 0 && (
        <>
          <h3>Categories</h3>
          <ul>
            {categories.map((cat) => (
              <li key={cat}>
                <a href="#" onClick={(e) => { e.preventDefault(); onSelectCategory(cat) }}
                   className={activeCategory === cat ? 'active' : ''}>
                  {cat}
                </a>
              </li>
            ))}
          </ul>
        </>
      )}

      <div className="sidebar-footer">
        <a href="/feeds">Manage Feeds</a>
      </div>
    </aside>
  )
}
